<div *ngIf = "dataIsLoaded">
  <div class="pipe-group-title">
    <mat-spinner *ngIf="!menuPipe" [diameter]="30"></mat-spinner>
    <div *ngIf="menuPipe && menuPipe.menuStatus.revision">
      <span>{{'MENU_HISTORY.REVISION' | translate}}: </span>
      <span class="revision">{{menuPipe.menuStatus.revision}}</span>
    </div>
    <div *ngIf="menuPipe">
      <span>{{'MENU_HISTORY.REVISION_UPDATED_AT' | translate}}: </span>
      <span class="revision">{{menuPipe.menuStatus.uploadedAt | utcToLocal: dateFormat}}</span>
      <span class="menu-button">
        <button mat-button (click)="uploadMenu()">
          <mat-icon *ngIf="!uploadingMenu">sync</mat-icon>
          <mat-spinner *ngIf="uploadingMenu" color="accent" style="display: inline-block;" [diameter]="24"></mat-spinner>
            Sync menu
        </button>
      </span>
      <span class="menu-button">
        <button mat-button (click)="goToMenuEventsAsync()">
          <mat-icon>event</mat-icon>
          <span>{{ 'MENU.LOGS' | translate }}</span>
        </button>
      </span>
      <span class="menu-button" *ngIf="showPipesButton">
        <button mat-button (click)="showPipes()">
          <mat-icon>vertical_split</mat-icon>
          <span>{{ 'MENU.SHOW_PIPES' | translate }}</span>
        </button>
      </span>
    </div>
  </div>

  <app-menu-chips (addNewMenu)="createMenuSection($event)"
                  (editMenu)="editMenuSection($event)"
                  (deleteMenu)="deleteMenuSection($event)"
                  (restoreMenu)="restoreMenuSection($event)"
                  (menuSectionSelected)="selectMenuSection($event)"
                  [selectedMenuSectionId]="currentMenuSection.id"
                  [roleMembership]="roleMembership"
                  [menuSections]="menuSections"
                  [menuBackups]="menuBackups"
                  (createMenuBackup)="createMenuBackup($event)"
                  (deleteBackup)="deleteMenuBackup($event)"
                  (downloadMenu)="downloadMenuByName($event)"
                  [isShowDeleted]="showDeletedMenuSections"
  ></app-menu-chips>

  <div class="main">
    <div class="groups">
      <div class="groups-label">{{ 'MENU.GROUPS' | translate }}</div>
      <mat-checkbox
        (change)="changeShowGroups($event.checked)"
        [checked]="isShowGroupHierarchy"
      >
        {{'MENU.SHOW_STRUCTURED_GROUP' | translate}}
      </mat-checkbox>
      <div class="menu-buttons">
        <app-menu-add-button *ngIf="allowOverrides"
                             class="list-add-button"
                             text="{{'MENU.NEW_GROUP' | translate}}"
                             (clicked)="onOpenCreateMenuGroupDialog()"></app-menu-add-button>
        <app-menu-add-button *ngIf="allowOverrides"
                             class="list-add-button"
                             icon="check"
                             text="{{'MENU.SELECT_GROUPS' | translate}}"
                             (clicked)="selectGroupsToMenu()"></app-menu-add-button>
      </div>

      <div class="groups-items" cdkDropList (cdkDropListDropped)="dropGroup($event)" [cdkDropListDisabled]="!allowOverrides || this.isShowGroupHierarchy">
        <div *ngFor="let group of getGroups()" class="groups-items-item"
             [class.groups-items-item__child]="isChildGroup(group)"
             [class.groups-items-item__child--last]="isLastChildInParent(group)"
             (click)="selectGroup(group)"
             [class.groups-items-item__selected]="group.externalId === selectedGroup?.externalId"
             [cdkDragData]="group"
             cdkDrag>
          <div
            style="{{getChildStyle(group)}}"
          >
            <app-menu-section-group [group]="group" [menuSection]="currentMenuSection"
                                    (editMenuGroup)="onOpenEditMenuGroupDialog($event)">
            </app-menu-section-group>
          </div>
          <div *cdkDragPlaceholder class="group-drag-placeholder"></div>
        </div>
      </div>
      <div>
        <div class="group-change-message">
          <span *ngIf="allowOverrides && hasReOrderingGroups()" class="isDifferent">{{'MENU.CHANGES_ORDER_GROUPS' | translate}}</span>
          <mat-icon *ngIf="allowOverrides && hasReOrderingGroups()" matSuffix mat-icon-button aria-label="Clear"
                    matTooltip="{{'MENU.CLEAR_MANUAL_SORTING' | translate}}" (click)="clearGroupSorting()">restore
          </mat-icon>
        </div>
        <div class="group-change-message">
          <span *ngIf="allowOverrides && hasDisabledGroups()" class="isDifferent">{{'MENU.SOME_GROUPS_HIDDEN' | translate}}</span>
        </div>
      </div>
    </div>

    <div class="dishes">
      <span class="menu-list-label">
        {{ 'MENU.DISHES.LIST_LABEL' | translate }}
      </span>
      <div class="menu-buttons">
        <!--        <app-menu-add-button class="list-add-button"-->
        <!--                             text="{{'MENU.NEW_DISH' | translate}}"-->
        <!--        ></app-menu-add-button>-->
        <app-menu-add-button *ngIf="allowOverrides" class="list-add-button"
                             icon="check"
                             text="{{'MENU.SELECT_PRODUCTS_IN_GROUP' | translate}}"
                             (clicked)="selectProductsToGroup()"></app-menu-add-button>
      </div>
      <div *ngIf="this.selectedGroup" class="dishes-container">
        <app-menu-section-products
          [originalProductsMap]="originalProducts"
          [productsMap]="products"
          [overridePositionsMap]="overridePositionsMap"
          [menuSection]="currentMenuSection"
          [currency]="currency"
          [group] = "this.selectedGroup"
          [searchQuery]="this.searchQuery"
          [menuPipes]="menuPipes"
          [currentOrganization] = "currentOrganization"
          [showKioskWarning]="canShowKioskWarning && groupHasChildren(selectedGroup)"
          (editProduct)="onOpenEditDialogProduct($event)"
        ></app-menu-section-products>
      </div>
      <div>
        <div class="group-change-message">
          <span *ngIf="allowOverrides && this.selectedGroup?.hasReOrderingProductInGroup " class="isDifferent">{{'MENU.CHANGED_ORDER_PRODUCT_IN_GROUP' | translate}}</span>
          <mat-icon *ngIf="this.selectedGroup?.hasReOrderingProductInGroup" matSuffix mat-icon-button aria-label="Clear"
                    matTooltip="{{'MENU.CLEAR_MANUAL_SORTING' | translate}}" (click)="clearProductSorting()">restore
          </mat-icon>
        </div>
        <div class="group-change-message">
          <span *ngIf="allowOverrides && this.selectedGroup?.assortmentHasChanged" class="isDifferent">{{'MENU.ASSORTMENT_GROUP_CHANGED' | translate}}</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="menuSyncsOfSale?.length" class="main-right">
    <div class="menu-sync-container">
      <div *ngFor="let sync of menuSyncsOfSale" class="menu-sync">
        <app-menu-sync-card [lastSync]="sync.lastSyncedAt" [pipeId]="sync.pipeId"
                            [serviceName]="sync.service"></app-menu-sync-card>
      </div>
    </div>
  </div>

</div>
